import type {
  StockRecommendationRequestBody,
  UseStockRecommendationQueryKey,
} from './types';

export const getStockRecommendationQueryKey = (
  params: StockRecommendationRequestBody,
): UseStockRecommendationQueryKey => ['vendors', 'stockRecommendation', params];
